
import { defineComponent, SetupContext } from "vue";
import NativeClient from "@/client/native-client";
import {} from "@/types/pantry";

export default defineComponent({
  name: "PantryUsedUpEmptyView",
  components: {
  },
  props: {
  },
  setup(props, context: SetupContext) {
    return {
    };
  }
});
